import { atom } from "jotai";

export const atomIsModalOpen = atom<boolean>(false);
export const atomModalEditItemIndex = atom<number | undefined>(undefined);
export const atomRowKeys = atom<string[] | undefined>(undefined);
